import React from "react";
import TargetTypeNameField from "../TargetTypeNameField";

function SectorNameField({ sector, setSector }) {
    const onChange = (value) => setSector({ ...sector, name: value, base: false });

    return (
        <TargetTypeNameField
            value={sector.name}
            onValueChange={onChange}
            label="Name"
        />
    );
}

export default SectorNameField;
